import React, { useRef } from 'react';
import Select from 'react-select';

import { ToolTip } from '../../../../common/tool-tip/ToolTip';

import './ClientAddressInformation.css';

export const ClientAddressInformation = ({
  context,
  toolTipsEnabled,
  showToaster,
  setSpinnerText,
  clientAddressInformation,
  clientAddressErrors,
  handleClientAddressInformationChange,
  fieldsDisabled,
}) => {
  const handlePrimaryProvinceChange = (selectedPrimaryOption) => {
    handleClientAddressInformationChange('selectedPrimaryProvince', selectedPrimaryOption);
  };

  const handleSecondaryProvinceChange = (selectedSecondaryOption) => {
    handleClientAddressInformationChange('selectedSecondaryProvince', selectedSecondaryOption);
  };

  const primaryProvinceList = useRef([
    'Eastern Cape Province',
    'Free State Province',
    'Gauteng Province',
    'KwaZulu-Natal Province',
    'Limpopo Province',
    'Mpumulanga Province',
    'Northern Cape Province',
    'North West Province',
    'Western Cape Province',
  ]);

  const secondaryProvinceList = useRef([
    'Eastern Cape Province',
    'Free State Province',
    'Gauteng Province',
    'KwaZulu-Natal Province',
    'Limpopo Province',
    'Mpumulanga Province',
    'Northern Cape Province',
    'North West Province',
    'Western Cape Province',
  ]);

  const renderLeftInputs = () => {
    return (
      <div className="form-section-left">
        <h4 className="client-address-header-left">Primary Address</h4>
        <div className="input-container">
          <label className={'input-label'}>Address Line 1:</label>
          <input
            className={`text-input ${clientAddressErrors.addressLineOneError && 'error-border'}`}
            type="text"
            value={clientAddressInformation.primaryAddressLine1}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('primaryAddressLine1', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientPrimaryAddressLineOne123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Address Line 1:'}
            />
          )}
        </div>
        <div className="error-message">
          {clientAddressErrors.addressLineOneError && (
            <div className="small-red-text">{clientAddressErrors.addressLineOneError}</div>
          )}
        </div>
        <div className="input-container">
          <label className={'input-label'}>Address Line 2:</label>
          <input
            className="text-input"
            type="text"
            value={clientAddressInformation.primaryAddressLine2}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('primaryAddressLine2', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientPrimaryAddressLineTow123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Address Line 2:'}
            />
          )}
        </div>
        <div className="input-container">
          <label className={'input-label'}>Suburb/Extension:</label>
          <input
            className={`text-input ${clientAddressErrors.suburbOneError && 'error-border'}`}
            type="text"
            value={clientAddressInformation.primarySuburb}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('primarySuburb', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientPrimarySuburb123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Suburb/Extension:'}
            />
          )}
        </div>
        <div className="error-message">
          {clientAddressErrors.suburbOneError && (
            <div className="small-red-text">{clientAddressErrors.suburbOneError}</div>
          )}
        </div>
        <div className="input-container">
          <label className={'input-label'}>City/Town:</label>
          <input
            className={`text-input ${clientAddressErrors.cityOneError && 'error-border'}`}
            type="text"
            value={clientAddressInformation.primaryCity}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('primaryCity', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientPrimaryCity123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'City/Town:'}
            />
          )}
        </div>
        <div className="error-message">
          {clientAddressErrors.cityOneError && <div className="small-red-text">{clientAddressErrors.cityOneError}</div>}
        </div>
        <div className="input-container">
          <label className={'input-label'}>Province:</label>
          <Select
            options={primaryProvinceList.current.map((origin, index) => ({
              value: origin,
              label: origin,
            }))}
            closeMenuOnSelect={true}
            onChange={handlePrimaryProvinceChange}
            value={clientAddressInformation.selectedPrimaryProvince || null}
            className="input-select"
            isDisabled={fieldsDisabled}
            classNamePrefix={`input-select${clientAddressErrors.provinceOneError && 'error-border'}`}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientPrimaryProvince123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Province:'}
            />
          )}
        </div>
        <div className="error-message">
          {clientAddressErrors.provinceOneError && (
            <div className="small-red-text">{clientAddressErrors.provinceOneError}</div>
          )}
        </div>
        <div className="input-container">
          <label className={'input-label'}>GPS Co-ordinates:</label>
          <input
            className={`text-input ${clientAddressErrors.GPSOneError && 'error-border'}`}
            type="text"
            value={clientAddressInformation.primaryGPSCoordinates}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('primaryGPSCoordinates', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientPrimaryCoordinates123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'GPS Co-ordinates:'}
            />
          )}
        </div>
        <div className="error-message">
          {clientAddressErrors.GPSOneError && <div className="small-red-text">{clientAddressErrors.GPSOneError}</div>}
        </div>
        <div className="input-container">
          <label className={'input-area-label'}>Additional Information:</label>
          <textarea
            className="input-area-sm"
            spellCheck={true}
            type="text"
            value={clientAddressInformation.primaryAdditionalInfo}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('primaryAdditionalInfo', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientPrimaryAddressAdditionalInfo123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Additional Information:'}
            />
          )}
        </div>
      </div>
    );
  };

  const renderRightInputs = () => {
    return (
      <div className="form-section-right">
        <div className="client-address-header-right">
          <h4>Secondary Address</h4>
          <h6>*Optional</h6>
        </div>

        <div className="input-container">
          <label className={'input-label-right'}>Address Line 1:</label>
          <input
            className="text-input"
            type="text"
            value={clientAddressInformation.secondaryAddressLine1}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('secondaryAddressLine1', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientSecondaryAddressLineOne123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Address Line 1:'}
            />
          )}
        </div>
        <div className="input-container">
          <label className={'input-label-right'}>Address Line 2:</label>
          <input
            className="text-input"
            type="text"
            value={clientAddressInformation.secondaryAddressLine2}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('secondaryAddressLine2', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientSecondaryAddressLineTow123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Address Line 2:'}
            />
          )}
        </div>
        <div className="input-container">
          <label className={'input-label-right'}>Suburb/Extension:</label>
          <input
            className="text-input"
            type="text"
            value={clientAddressInformation.secondarySuburb}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('secondarySuburb', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientSecondarySuburb123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Suburb/Extension:'}
            />
          )}
        </div>
        <div className="input-container">
          <label className={'input-label-right'}>City/Town:</label>
          <input
            className="text-input"
            type="text"
            value={clientAddressInformation.secondaryCity}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('secondaryCity', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientSecondaryCity123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'City/Town:'}
            />
          )}
        </div>
        <div className="input-container">
          <label className={'input-label-right'}>Province:</label>
          <Select
            options={secondaryProvinceList.current.map((origin, index) => ({
              value: origin,
              label: origin,
            }))}
            closeMenuOnSelect={true}
            onChange={handleSecondaryProvinceChange}
            value={clientAddressInformation.selectedSecondaryProvince || null}
            className="input-select"
            isDisabled={fieldsDisabled}
            classNamePrefix="input-select"
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientSecondaryProvince123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Province:'}
            />
          )}
        </div>
        <div className="input-container">
          <label className={'input-label-right'}>GPS Co-ordinates:</label>
          <input
            className={`text-input ${clientAddressErrors.GPSTwoError && 'error-border'}`}
            type="text"
            value={clientAddressInformation.secondaryGPSCoordinates}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('secondaryGPSCoordinates', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientSecondaryCoordinates123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'GPS Co-ordinates:'}
            />
          )}
        </div>
        <div className="error-message">
          {clientAddressErrors.GPSTwoError && <div className="small-red-text">{clientAddressErrors.GPSTwoError}</div>}
        </div>
        <div className="input-container">
          <label className={'input-area-label-right'}>Additional Information:</label>
          <textarea
            className="input-area-sm"
            spellCheck={true}
            type="text"
            value={clientAddressInformation.secondaryAdditionalInfo}
            disabled={fieldsDisabled}
            onChange={({ target }) => {
              handleClientAddressInformationChange('secondaryAdditionalInfo', target.value);
            }}
          />
          {toolTipsEnabled && (
            <ToolTip
              tooltipExternalReference={'clientSecondaryAddressAdditionalInfo123'}
              context={context}
              setSpinnerText={setSpinnerText}
              showToaster={showToaster}
              fieldName={'Additional Information:'}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="tab-container client-address-information">
      <div className="client-address-inputs">
        {renderLeftInputs()}
        {renderRightInputs()}
      </div>
    </div>
  );
};
